import { Component, OnInit, Output } from '@angular/core';
import { DocumentSearchResult } from '../../../app/document/models/documentSearchResult';
import { MyFavoritesService } from '../services/my-favorites.service'
import { DocumentLibraryConstants } from '../../../app/document/document-library-constants';
import { MessageService } from 'primeng/api';
import { LabelConstants } from '../../shared/constants/label-constants';

@Component({
  selector: 'app-my-favorites-list',
  templateUrl: './my-favorites-list.component.html',
  styleUrls: ['./my-favorites-list.component.scss']
})
export class MyFavoritesListComponent implements OnInit {
  documentSearchResult: DocumentSearchResult[] = [];
  dispalyCheckBoxes: boolean = false;
  displayInActiveButton: boolean = true;
  enableDocumentFavoriteCheck: boolean = true
  isIncludeInactive: boolean = false;
  displayInActiveLabel: boolean = true;
  displayInformationIconCheckbox: boolean = true;
  informationIconToolTipMessage: string = DocumentLibraryConstants.ToolTipMessage_InActiveIcon;
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  showLoader: boolean = true;

  constructor(private myFavoritesService: MyFavoritesService, private messageService : MessageService){}
  
  ngOnInit(): void {
    this.getPanelListData(this.isIncludeInactive);
  }

  getPanelListData(isIncludeInactive: boolean){
    this.myFavoritesService.getFavoriteDocuments(isIncludeInactive)
        .subscribe({
            error: (err) => {
                if (err.status === LabelConstants.Forbidden_StatusCode) {
                    this.errorMessage = err.error.detail;
                }
                this.isScreenAccessible = false
            },
            next: (serviceData) => {
                this.documentSearchResult = serviceData;
                this.showLoader = false;
            }
    });
  }
  
}
